import React, { Suspense } from 'react';
import { Route, Switch, useLocation } from 'react-router-dom';
import AppContainer from '../AppContainer';
import PageLoadingAnimation from '../components/PageLoadingAnimation/PageLoadingAnimation';
import LoginPage from '../pages/LoginPage/LoginPage';
import { PAGE_ROUTES } from '../utils/constants';

const BranchesPage = React.lazy(() => import('../pages/Branches/BranchesPage'));

type Props = {};

const Routes = (props: Props) => {
    console.log(props);
    const location = useLocation();
    return (
        <div>
            <Route exact path={PAGE_ROUTES.BASE_ROUTE} component={LoginPage} />
            {
                location.pathname !== PAGE_ROUTES.BASE_ROUTE && (
                    <Switch>
                        <AppContainer>
                            <Suspense
                                fallback={(
                                    <PageLoadingAnimation />
                                )}
                            >
                                <Route
                                    path={PAGE_ROUTES.BRANCHES}
                                    component={BranchesPage}
                                />
                            </Suspense>
                        </AppContainer>
                    </Switch>
                )
            }
        </div>
    );
};

export default Routes;
